import {
  Button,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Link,
} from '@ritualco/jutsu'
import { useMerchantListQuery } from 'api/endpoints/merchantLists'
import { ReactComponent as ExternalLinkIcon } from 'assets/Icons/OpenInNew.svg'
import { MaxWidthPage, PageDivider } from 'components/PageTemplates'
import { useTabControl } from 'hooks/useTabControl'
import { useContent } from 'lib/content/react'
import { DetailsSection } from './DetailsSection'
import { ListSection } from './ListSection'
import { ShareSection } from './ShareSection'
import Loading from 'components/Loading'

type MerchantListProps = {
  organizationId: string
  workspaceId: string
  merchantListId: string
  tabPaths: string[]
}

const MerchantList = ({
  organizationId,
  workspaceId,
  merchantListId,
  tabPaths,
}: MerchantListProps) => {
  const { formatMessage } = useContent()
  const { status, data } = useMerchantListQuery({
    organizationId,
    workspaceId,
    merchantListId,
  })
  const [tabIndex, handleTabChange] = useTabControl(tabPaths)

  if (status === 'loading') {
    return <Loading />
  }

  if (status === 'error') {
    // TODO: handle error state
    return <span>Something went wrong!</span>
  }

  if (!data) {
    // TODO: handle no data state
    return <span>404 Not Found</span>
  }

  const { name, type, merchants, url, qrCodeUrl } = data

  return (
    <MaxWidthPage
      heading={<Heading fontSize="2xlarge">{name}</Heading>}
      actions={
        <Link
          href={url}
          target="_blank"
          sx={{
            _hover: { textDecoration: 'none' },
          }}
        >
          <Button
            colorScheme="transparent"
            variant="outline"
            rightIcon={<ExternalLinkIcon style={{ height: 18, width: 18 }} />}
          >
            {formatMessage({
              id: 'pmportal.restaurantLists.previewListAction',
            })}
          </Button>
        </Link>
      }
      showDivider={false}
    >
      <Tabs variant="soft-rounded" index={tabIndex} onChange={handleTabChange}>
        <TabList mb={4}>
          <Tab>
            {formatMessage({ id: 'pmportal.restaurantLists.editListTab' })}
          </Tab>
          <Tab isDisabled={!qrCodeUrl && !url}>
            {formatMessage({ id: 'pmportal.restaurantLists.shareListTab' })}
          </Tab>
        </TabList>
        <PageDivider />
        <TabPanels>
          <TabPanel>
            <DetailsSection
              organizationId={organizationId}
              workspaceId={workspaceId}
              merchantListId={merchantListId}
              name={name}
              type={type}
            />
            <ListSection
              organizationId={organizationId}
              workspaceId={workspaceId}
              merchantListId={merchantListId}
              merchants={merchants}
            />
          </TabPanel>
          <TabPanel>
            <ShareSection qrCodeUrl={qrCodeUrl} url={url} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </MaxWidthPage>
  )
}

export default MerchantList
